import { ResourceRewards } from '@entities/game-resource';

import type { CampaignCosmetic } from '../model/campaign-cosmetics';
import type { CampaignRewards } from '../model/campaign-rewards';
import { CampaignCosmetics } from './campaign-cosmetics';

import classes from './campaign-completion-rewards.module.css';

type Props = {
  cosmetics: readonly CampaignCosmetic[];
  rewards: CampaignRewards;
};

export const CampaignCompletionRewards = ({ cosmetics, rewards }: Props) => {
  const hasResources = [
    rewards.lives,
    rewards.inventory?.fiftyFifty,
    rewards.inventory?.freeze,
    rewards.inventory?.swapFrame,
  ].some((amount) => (amount ?? 0) > 0);

  if (!cosmetics.length && !hasResources) return null;

  return (
    <span className={classes.root} role="group" aria-label="Награды за прохождение">
      <span className={classes.label}>Награды</span>
      <span className={classes.items}>
        <CampaignCosmetics items={cosmetics} />
        <ResourceRewards rewards={rewards} />
      </span>
    </span>
  );
};
